import { useState } from 'react';
import { KPI_AVG, KPI_GRADES, KPI_STAFF, fmtVi } from './kpi';
import s from './kpiDock.module.css';

// Bảng phải của Mint-KPI-1920 (Tóm tắt kỳ · Cách đọc). Dữ liệu mẫu của board; không tiền.

type DockTab = 'sum' | 'how';
type Item = { k: string; s: string; c: string };
type Sec = { k: string; s: string; items: Item[]; link?: string };

const BLUE = 'var(--d-blue)';
const SECS: Record<DockTab, Sec[]> = {
  sum: [
    {
      k: 'Kỳ Oct/2026',
      s: 'đang mở',
      items: [
        { k: `Điểm TB công ty ${fmtVi(KPI_AVG)}`, s: `${KPI_STAFF.scored} người có điểm`, c: BLUE },
        { k: `Hạng D: ${KPI_GRADES.D} người`, s: 'xem theo phòng', c: 'var(--err)' },
      ],
    },
    {
      k: 'Sai sót & khen thưởng',
      s: 'sổ ở Báo cáo BOD',
      items: [{ k: '4 vụ đang mở', s: '1 chờ BOD duyệt · 2 chờ TP · 2 chờ giải trình', c: 'var(--d-amber)' }],
      link: 'Mở sổ ›',
    },
  ],
  how: [
    {
      k: 'Cách đọc',
      s: 'điểm chất lượng tách khỏi điểm thưởng sản lượng',
      items: [
        { k: 'Điểm 0–100 theo từng chỉ số', s: 'mốc sàn / mục tiêu / vượt: chờ anh chốt', c: BLUE },
        { k: 'Hạng A / B / C / D', s: 'ngưỡng tạm 90 / 75 / 60 · chờ anh chốt', c: BLUE },
        { k: 'Cột "Số liệu"', s: 'Thực tế = đếm thật · Mẫu = số mẫu', c: 'var(--ok)' },
        { k: 'Trưởng phòng chỉ xem phòng mình', s: 'nhân viên chỉ xem KPI của tôi', c: 'var(--d-amber)' },
      ],
    },
  ],
};

export function HrKpiDock({ onClose, onNote }: { onClose: () => void; onNote: (msg: string) => void }) {
  const [tab, setTab] = useState<DockTab>('sum');
  const tabs: Array<[DockTab, string]> = [['sum', 'Tóm tắt kỳ'], ['how', 'Cách đọc']];
  return (
    <div className={s.dock} aria-label="Cột phải">
      <div className={s.head}>
        <div role="tablist" aria-label="Cột phải" className={s.tabs}>
          {tabs.map(([k, l]) => (
            <button key={k} type="button" role="tab" aria-selected={tab === k} className={`${s.tab} ${tab === k ? s.on : ''}`} onClick={() => setTab(k)}>{l}</button>
          ))}
        </div>
        <button type="button" className={s.close} aria-label="Đóng cột phải" onClick={onClose}>×</button>
      </div>
      {SECS[tab].map((sec) => (
        <section key={sec.k} className={s.sec}>
          <h2>{sec.k}</h2>
          <div className={s.sub}>{sec.s}</div>
          {sec.items.map((n, i) => (
            <button key={n.k} type="button" className={`${s.item} ${i === 0 ? s.first : ''}`} onClick={() => onNote(n.k)}>
              <span className={s.dot} style={{ background: n.c }} />
              <span><b>{n.k}</b><small>{n.s}</small></span>
            </button>
          ))}
          {sec.link && <button type="button" className={s.link} onClick={() => onNote('Sổ ở Báo cáo BOD · chưa mở ở bản này')}>{sec.link}</button>}
        </section>
      ))}
    </div>
  );
}
